import standardAction from '../../../utilities/standard-action';
import { ActionTypes } from '../constants';
import { RootActionTypes } from '../../../stores/types';

export default function closeExport(): RootActionTypes {
  return standardAction(ActionTypes.CLOSE_SCHEDULED_EXPORT);
}
